import { eventChannel } from 'redux-saga';
import { call, fork, put, select, take, takeEvery } from 'redux-saga/effects';
import { ErrorCode, MetaTransactionError } from 'decentraland-transactions';
import { renderToast, SHOW_TOAST, HIDE_TOAST, showToast, hideAllToasts } from './actions';
import { getState } from './selectors';
import * as cache from './cache';
import { TransactionEventType } from '../wallet/utils/types';
import { transactionEvents } from '../wallet/utils/transactionEvents';
import { SWITCH_NETWORK_SUCCESS } from '../wallet/actions';
import { getContractAccountErrorToast, getHighCongestionErrorToast, getInvalidAddressErrorToast, getSalePriceTooLowErrorToast, getUnknownErrorToast } from './toasts/meta-transactions';
export function* toastSaga() {
    yield fork(watchMetaTransactionErrors);
    yield takeEvery(SHOW_TOAST, handleShowToast);
    yield takeEvery(HIDE_TOAST, handleHideToast);
    yield takeEvery(SWITCH_NETWORK_SUCCESS, handleSwitchNetworkSuccess);
}
function* handleShowToast(action) {
    const { toast, position } = action.payload;
    const ids = yield select(getState);
    const lastId = Number(ids[ids.length - 1] || 0);
    const id = lastId + 1;
    cache.set(id, toast, position);
    yield put(renderToast(id));
}
function* handleHideToast(action) {
    const { id } = action.payload;
    cache.remove(id);
}
export function createMetaTransactionsErrorChannel() {
    return eventChannel(emitter => {
        function handleError(data) {
            if (data.error instanceof MetaTransactionError) {
                emitter(data.error.code);
            }
        }
        transactionEvents.on(TransactionEventType.ERROR, handleError);
        return () => transactionEvents.removeListener(TransactionEventType.ERROR, handleError);
    });
}
export function* watchMetaTransactionErrors() {
    const channel = yield call(createMetaTransactionsErrorChannel);
    while (true) {
        const code = yield take(channel);
        yield call(handleMetaTransactionError, code);
    }
}
export function* handleMetaTransactionError(code) {
    switch (code) {
        case ErrorCode.CONTRACT_ACCOUNT: {
            yield put(showToast(getContractAccountErrorToast()));
            break;
        }
        case ErrorCode.INVALID_ADDRESS: {
            yield put(showToast(getInvalidAddressErrorToast()));
            break;
        }
        case ErrorCode.SALE_PRICE_TOO_LOW: {
            yield put(showToast(getSalePriceTooLowErrorToast()));
            break;
        }
        case ErrorCode.USER_DENIED: {
            // do nothing
            break;
        }
        case ErrorCode.HIGH_CONGESTION: {
            yield put(showToast(getHighCongestionErrorToast()));
            break;
        }
        case ErrorCode.UNKNOWN:
        default: {
            yield put(showToast(getUnknownErrorToast()));
            break;
        }
    }
}
function* handleSwitchNetworkSuccess() {
    yield put(hideAllToasts());
}
//# sourceMappingURL=sagas.js.map